export enum UserRole {
	ACCOUNTANT = 'ACCOUNTANT',
	DIRECTOR = 'DIRECTOR',
	EMPLOYEE = 'EMPLOYEE',
}

export type ValueByRole<T = any> = {
	[P in UserRole]: T
}